import {NOTIFY_EVENT_NAMES} from 'constants/client';
import {SessionFeedback} from 'interfaces';
import {NotifyClientResult, RequestAppointmentDetails} from 'types';

export abstract class ClientNotifier {

    abstract notify: (method: string, ...args) => NotifyClientResult;
    abstract formatResult: (result: NotifyClientResult) => NotifyClientResult;

    /**
     * received when the webapp finished loading
     */
    appReady = (): NotifyClientResult => this.notify(NOTIFY_EVENT_NAMES.APP_READY);

    /**
     * received when user info or assignment validation failed
     */
    validationError = (errorType: string): NotifyClientResult =>
        this.notify(NOTIFY_EVENT_NAMES.VALIDATION_ERROR, errorType);

    /**
     * Received on app open if agents are available
     */
    agentsAvailable = (): NotifyClientResult => this.notify(NOTIFY_EVENT_NAMES.AGENTS_AVAILABLE);

    /**
     * Received on app open if agents are not available
     */
    agentsUnavailable = (): NotifyClientResult => this.notify(NOTIFY_EVENT_NAMES.AGENTS_UNAVAILABLE);

    /**
     * Received when client calls out of working hours
     */
    afterHours = (date: number): NotifyClientResult => this.notify(NOTIFY_EVENT_NAMES.AFTER_HOURS, {date});

    /**
     * Received when a client sent feedback
     */
    feedbackSent = (feedback: SessionFeedback): NotifyClientResult => this.notify(NOTIFY_EVENT_NAMES.FEEDBACK_SENT, feedback);

    /**
     * Received when a client requests an appointment
     */
    appointmentRequested = (fields: RequestAppointmentDetails): NotifyClientResult =>
        this.notify(NOTIFY_EVENT_NAMES.APPOINTMENT_REQUESTED, fields);

    /**
     * When call started
     */
    sessionStarted = (): NotifyClientResult => this.notify(NOTIFY_EVENT_NAMES.SESSION_STARTED);

    /**
     * When status changed and settings said to notify about it
     */
    sessionStatusChanged = (data: any): NotifyClientResult => this.notify(NOTIFY_EVENT_NAMES.SESSION_STATUS_CHANGED, data);

    /**
     * When call finished
     */
    sessionClosed = (): NotifyClientResult => this.notify(NOTIFY_EVENT_NAMES.SESSION_CLOSED);

    /**
     * Received when the agent clicks on "Success"
     */
    sessionSuccess = (details?: string): NotifyClientResult => {
        if (details) {
            return this.notify(NOTIFY_EVENT_NAMES.SESSION_SUCCESS, details);
        }
        return this.notify(NOTIFY_EVENT_NAMES.SESSION_SUCCESS);
    };

    /**
     * Received when the agent clicks on "Report a problem"
     */
    sessionFailed = (details?: string): NotifyClientResult => this.notify(NOTIFY_EVENT_NAMES.SESSION_FAILED, details);

    /**
     * Received when agent requests client's selfie
     * @param {string} base64ImageData
     */
    validateSelfie = (base64ImageData: string): NotifyClientResult =>
        this.notify(NOTIFY_EVENT_NAMES.VALIDATE_SELFIE, base64ImageData);

}
